export const ticketBorder = {
    paddingTop: "10px",
    borderBottom: "solid 4px black"
};
